import { getUser } from '@/app/(actions)/user/getUser';
import { useQuery } from '@tanstack/react-query';

import { AxiosError } from 'axios';
export const USER_QUERY_KEY = 'user';

export const useUserQuery = () => {
  return useQuery({
    queryKey: [USER_QUERY_KEY],
    queryFn: async () => {
      try {
        return await getUser();
      } catch (error) {
        if (error instanceof AxiosError && error.response?.status === 401) {
          return null;
        }
        throw error;
      }
    },

    throwOnError: false,
  });
};
